export const CONTACTS = {
  PHONE: '+7 (495) 104-71-24',
  PHONE_CHECKIN: '+7 (495) 487-00-00',
  MAIL: 'forma@forma.ru',
  MAIL_CHECKIN: 'documents@forma.ru',
  ADDRESS: 'Москва, 2-ой Красногорский проезд',
  ADDRESS_CHECKIN: 'Москва, пр-д 3-й Красногорский, д.2',
  TIME: 'Ежедневно с 9:00 до 21:00',
};
